import React from 'react';
import get from 'lodash/get';
import { withStructureContext } from '@Components/Results/structure/StructureContext';
import StructureToolbarZoomComponent from '@Components/Results/structure/StructureToolbarZoom';
import ShoppingCart from '@Components/Results/structure/availability/ShoppingCart';
import StructureSynthesisComponent from '@Components/Results/structure/structure-synthesis.component';
import SubstanceDetails from '@Components/Results/structure/substance-details/SubstanceDetails';
import UserDatabases from '@Services/UserDatabases';
import { contextFromMetadata } from '@Components/Results/utils/metadata';
import StructureToolbarOptionsComponentLegacyContext from '@Components/Results/structure/StructureToolbarOptionsContext';
import { TooltipConstants } from '@Components/Tooltip';
import StructureToolbarCustomerIcon from './StructureToolbarCustomerIcon';
import { isCustomerIconVisible } from './structure-utils';

class StructureToolbarComponent extends React.Component {
  optionsAvailable() {
    const { markushRef, markushStr } = get(this.props, 'structure.details');
    const databaseId = get(this.props, 'structure.databaseId');
    const structureMixture = get(this.props, 'structure.mixture');
    const mixture = !!get(this.props, 'structure.details.mixtureItems');
    const fromDocuments = get(this.props, 'metadata.fromDocuments');
    const fromRT = get(this.props, 'metadata.fromRT');
    const fromSynthesisPlanner = get(this.props, 'metadata.fromSynthesisPlanner');
    const isTargets = get(this.props, 'metadata.context') === 'tgitems';
    const isViewPreview = get(this.props, 'metadata.isViewPreview');
    const canUseStructureAsFilter =
      !!get(this.props, 'structure.molImage.structure') &&
      !isViewPreview &&
      !fromDocuments &&
      !isTargets &&
      !fromSynthesisPlanner &&
      !fromRT;
    const isMolImagePropertyPresent = !!get(this.props, 'structure.molImage.path');
    const heatmapMode = !!get(this.props, 'metadata.heatmapMode');
    const rxn = !!get(this.props, 'metadata.rxnFile');
    const isReaxysContent = UserDatabases.isDefaultDatabase(databaseId);
    const showMixtureOptions = !structureMixture && !mixture;
    const showViewDetails = mixture && heatmapMode;
    const isSubstances = get(this.props, 'metadata.context') === 'substances';
    const isReactions = get(this.props, 'metadata.context') === 'reactions';
    const isStructuredSubstance = !!get(this.props, 'structure.molImage.structure');

    return (
      (!(mixture || !isMolImagePropertyPresent) && isStructuredSubstance) ||
      isViewPreview ||
      !isSubstances ||
      // eslint-disable-next-line radix
      (!mixture && parseInt(markushRef) > 0 && isReaxysContent) ||
      showViewDetails ||
      (showMixtureOptions && (isStructuredSubstance || isReactions || canUseStructureAsFilter || markushStr || rxn))
    );
  }

  render() {
    const { availability, supplierNumber, molImage, customerInfo } = get(this.props, 'structure');
    const fromSynthesisPlanner = get(this.props, 'metadata.fromSynthesisPlanner');
    const isTargets = get(this.props, 'metadata.context') === 'tgitems';
    const mixture = !!get(this.props, 'structure.details.mixtureItems');
    const showCustomerIcon = isCustomerIconVisible(customerInfo);
    const isMolImagePropertyPresent = molImage && molImage.path;
    const isMolImageStructurePresent = get(molImage, 'structure');
    const heatmapMode = !!get(this.props, 'metadata.heatmapMode');
    const optionsAvailable = this.optionsAvailable();
    const trackingContext = contextFromMetadata(get(this.props, 'metadata'));
    const tooltipId = TooltipConstants.ids.ResultStructureComponent;
    const xrnId = get(this.props, 'structure.details.id');
    return (
      <div className="structure-options-bottom">
        {showCustomerIcon ? (
          <div className="structure-options-item--wrapper">
            <StructureToolbarCustomerIcon structure={isMolImageStructurePresent} customerInfo={customerInfo} />
          </div>
        ) : null}

        {mixture || !isMolImagePropertyPresent ? null : (
          <div className="structure-options-item--wrapper">
            {availability ? (
              <ShoppingCart
                tooltipId={!fromSynthesisPlanner && tooltipId}
                tooltipPlace={isTargets && 'left'}
                availability={availability}
                structure={get(this.props, 'structure')}
                trackingContext={trackingContext}
                supplierNumber={supplierNumber}
              />
            ) : null}
          </div>
        )}

        {mixture || !isMolImagePropertyPresent || !xrnId ? null : (
          <div className="structure-options-item--wrapper">
            <StructureSynthesisComponent
              tooltipId={!fromSynthesisPlanner && tooltipId}
              tooltipPlace={isTargets && 'left'}
              trackingContext={trackingContext}
            />
          </div>
        )}

        {mixture || !isMolImagePropertyPresent || !isMolImageStructurePresent ? null : (
          <div className="structure-options-item--wrapper">
            <StructureToolbarZoomComponent
              tooltipId={!fromSynthesisPlanner && tooltipId}
              tooltipPlace={isTargets && 'left'}
              heatmapMode={heatmapMode}
            />
          </div>
        )}

        {xrnId && (
          <div className="structure-options-item--wrapper">
            <SubstanceDetails
              tooltipId={!fromSynthesisPlanner && tooltipId}
              tooltipPlace={isTargets ? 'left' : null}
              structure={get(this.props, 'structure')}
              reactionId={get(this.props, 'metadata.id')}
              trackingContext={trackingContext}
              metadata={get(this.props, 'metadata')}
            />
          </div>
        )}

        {optionsAvailable && xrnId && (
          <div className="structure-options-item--wrapper">
            <StructureToolbarOptionsComponentLegacyContext
              tooltipId={!fromSynthesisPlanner && tooltipId}
              tooltipPlace={isTargets && 'left'}
              trackingContext={trackingContext}
            />
          </div>
        )}
      </div>
    );
  }
}

export default withStructureContext(StructureToolbarComponent);
